import React from "react";
import { Skeleton } from "components/Skeleton";
import { MatchCardSkeleton } from "./Events/MatchCardSkeleton";

import * as styles from "./BettingPageSkeleton.module.scss";

export const BettingPageSkeleton = () => {
  return (
    <>
      <div className={styles.tabs}>
        <Skeleton shape="rect" className={styles.tab} />
        <Skeleton shape="rect" className={styles.tab} />
        <Skeleton shape="circle" className={styles.sgmButton} />
      </div>
      <div className={styles.titleFilter}>
        {Array.from({ length: 12 }).map((_, index) => (
          <Skeleton
            key={`sports-skeleton-title-${index}`}
            shape="circle"
            className={styles.title}
          />
        ))}
      </div>

      <div className={styles.cards}>
        {Array.from({ length: 8 }).map((_, index) => (
          <MatchCardSkeleton key={`sports-skeleton-match-${index}`} />
        ))}
      </div>
    </>
  );
};
